module.exports = __webpack_public_path__ + "static/media/cdr.95d454e0.zip";